import { useEffect } from "react";

const useGameControls = (enabled, onLeft, onRight) => {
  useEffect(() => {
    if (!enabled) return;

    const handleKeyDown = (event) => {
      if (event.key === "ArrowLeft") onLeft();
      else if (event.key === "ArrowRight") onRight();
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [enabled, onLeft, onRight]);
};

export default useGameControls;
